<template>
    <div>
        <legend>Роуты</legend>
        <table class="table table-sm small table-bordered table-hover">
            <tbody>
            <tr v-for="route in routes">
                <td>{{route.path}}</td>
                <td>{{route.method}}</td>
                <td><input type="checkbox" v-model="route.UnAuth" @change="upsert(route)"></td>
                <td width="500">
                    <v-select v-model="route.roles" label="Name" :filterable="false"
                              taggable
                              multiple
                              @input="upsert(route)"
                              :options="roles">
                        <template slot="no-options">
                            начните вводить...
                        </template>
                    </v-select>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import { get, post } from '@/admin/services/api/http-utils';

const url = `${process.env.VUE_APP_API_HOST}admin/route`;

export default {
  components: {},
  data() {
    return {
      routes: [],
      roles: [],
    };
  },
  created() {
    this.fetchRoutes();
    this.fetchRoles();
  },
  methods: {
    async fetchRoutes() {
      const { data } = await get(`${url}`);
      this.routes = data;
    },
    async fetchRoles() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/role`);
      this.roles = data.data;
    },
    async upsert(role) {
      await post(`${url}`, role).then((res) => {
        console.log(res)
      });
    }
  },
};
</script>
